import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './ZoomMap.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

import { Svg_Close } from "../../Svg";

interface ZoomMapData {
    map? : React.ReactNode;
}

export default function PopUp_ZoomMap() {

    const [ modalData, setModaldata ] = useState<ZoomMapData>({});
    const [ showPopUp, setShowPopUp ] = useState(false);

    function ClosePopUp(){
        SetModalState('ZoomMap', false);
    }

    useEffect(()=>{
        RegisterModalData('ZoomMap', setModaldata);
        RegisterModalObserver('ZoomMap', setShowPopUp);
    }, []);

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">
                <div className="all ZoomMap">
                    <div className="div_title">
                        <div className="">World Map</div>
                        <div className="close" onClick={ ClosePopUp }>
                            <Svg_Close className="icons" color="#B1B2B2" />
                        </div>
                    </div>
                    <div className="div_data">
                        {
                            modalData.map ? modalData.map
                            : <div className="div_no_data">No data to show</div>
                        }
                    </div>
                </div>
                <div className="close_all" onClick={ ClosePopUp } />
            </div>
        : <React.Fragment></React.Fragment>)
    )
}
